import React, {FC} from 'react';
import styled from 'styled-components';

import {UploadedAttachmentModel} from '../../../models/api/attachmentModel';
import {useImageLoadingState} from '../imageHooks';

/*
 * Props.
 */

interface CommentAttachmentProps {
  attachment: UploadedAttachmentModel;
}

/*
 * Style.
 */

const StyledDiv = styled.div`
  margin: 4px 2px 6px;
`;

const StyledImage = styled.img`
  max-width: 300px;
  max-height: 100px;
  object-fit: contain;
`;

/*
 * Component.
 */

export const CommentAttachment: FC<CommentAttachmentProps> = (props) => {
  const {onLoad, imageRef, isLoaded} = useImageLoadingState(props.attachment.url);

  return (
    <StyledDiv>
      <StyledImage
        ref={imageRef}
        src={props.attachment.url}
        alt={props.attachment.name}
        onLoad={onLoad}
        style={{opacity: isLoaded ? 1 : 0}}
      />
    </StyledDiv>
  );
};
